import * as React from 'react';

export function NoDataComponent() {
  return (
    <div className="text-center mar-v-4">
      <p>There is no data to display.</p>
    </div>
  );
}
